import {
	isValid,
	format,
	parseISO,
	toDate,
	millisecondsToSeconds,
} from 'date-fns';

function getFormattedDateBase(
	utcDate: string | undefined,
	formatString = 'PP',
	invalidFallback = 'Invalid Date',
): string {
	const date = utcDate ? parseISO(utcDate) : null;
	if (!date || !isValid(date)) return invalidFallback;

	return format(date, formatString);
}

export const getReadableDate = (
	utcDate: string | undefined,
	formatString: 'PP' | 'PPp' = 'PP',
) => getFormattedDateBase(utcDate, formatString);

export const getReadableTime = (
	utcDate: string | undefined,
	formatString = 'HH:mm',
) => getFormattedDateBase(utcDate, formatString, 'Invalid Time');

export const durationInHHmmSS = (milliseconds: number): string => {
	const totalSeconds = millisecondsToSeconds(milliseconds);
	const date = toDate(new Date(0, 0, 0, 0, 0, totalSeconds));

	if (milliseconds < 1000) return milliseconds + ' ms';
	if (milliseconds >= 1000 && milliseconds < 60000)
		return millisecondsToSeconds(milliseconds) + ' sec';
	if (milliseconds >= 60000 && milliseconds < 3600000)
		return date.getMinutes() + ' min ' + date.getSeconds() + ' sec';
	if (milliseconds >= 3600000)
		return (
			date.getHours() +
			' h ' +
			date.getMinutes() +
			' min ' +
			date.getSeconds() +
			' sec'
		);
	return '';
};
